import {
  Bell,
  Check,
  ChevronRight,
  CircleDollarSign,
  Cloud,
  Coffee,
  Droplets,
  Heart,
  Leaf,
  MoonStar,
  Pause,
  RefreshCcw,
  SlidersHorizontal,
  Sparkles,
  Waves,
  type LucideIcon,
} from 'lucide-react'

const icons: Record<string, LucideIcon> = {
  coffee: Coffee,
  sparkles: Sparkles,
  droplets: Droplets,
  refresh: RefreshCcw,
  moon: MoonStar,
  pause: Pause,
  heart: Heart,
  sliders: SlidersHorizontal,
  cloud: Cloud,
  waves: Waves,
  leaf: Leaf,
  bell: Bell,
  price: CircleDollarSign,
  check: Check,
  chevron: ChevronRight,
}

export function Icon({ name, size = 20 }: { name: string; size?: number }) {
  const Component = icons[name] ?? Sparkles
  return <Component size={size} strokeWidth={1.7} aria-hidden="true" />
}
